export function multipleError(errors: string[]) {
  if (errors?.length > 0) {
    showErrors(errors, 0);
  }
}

function showErrors(errors: string[], currentError: number) {
  this.snack
    .open(errors[currentError], "OK", { duration: 4000 })
    .afterDismissed()
    .subscribe(() => {
      if (currentError < errors.length - 1)
        this.showErrors(errors, currentError + 1);
    });
}
